import { SESSION_FORM_DATA_KEY } from './constants';

export default class JraDeleteBackCache {
  constructor() {
    window.sessionStorage.removeItem(SESSION_FORM_DATA_KEY);
  }
}
